import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tabletop from './pages/Tabletop';
import Engineering from './pages/Engineering';
import PrivacyByDesign from './pages/PrivacyByDesign';
import Team from './pages/Team';
import PrivacyNotice from './pages/PrivacyNotice';
import NoAccess from './pages/NoAccess';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  return (
    <div style={{ margin: 0, padding: 0, background: '#0a0a1a', minHeight: '100vh' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
          <Route path="/tabletop" element={
            <ProtectedRoute><Tabletop /></ProtectedRoute>
          } />
          <Route path="/engineering" element={
            <ProtectedRoute><Engineering /></ProtectedRoute>
          } />
          <Route path="/privacy-by-design" element={
            <ProtectedRoute><PrivacyByDesign /></ProtectedRoute>
          } />
          <Route path="/team" element={
            <ProtectedRoute><Team /></ProtectedRoute>
          } />
          <Route path="/privacy" element={<PrivacyNotice />} />
          <Route path="/no-access" element={<NoAccess />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}